import { apiLegacy } from "@/services/api-legacy";
import { useCallback } from "react";
import useSWR from "swr";
import { UseApiProps } from "./use-api.types";

export const useApi = ({
  method,
  path,
  body,
  service = apiLegacy,
}: UseApiProps) => {
  const fetcher = useCallback(
    (url: string) => service[method](url, body).then((res) => res.data),
    [method, body, service],
  );

  const { data, mutate, error } = useSWR(path, fetcher, {
    suspense: true,
  });

  return { data, mutate, error };
};
